export default __webpack_public_path__ + "static/media/mail.bcb18744.svg";